import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NAV_FOOTER, NAV_MAIN } from './navConfig.js';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandShortcut,
} from '@/components/ui/command';

function flattenNav() {
  const items = [];
  for (const item of NAV_MAIN) {
    if (item.show?.() === false) continue;
    items.push({ route: item.route, label: item.label, group: 'Navigation' });
  }
  for (const group of NAV_FOOTER) {
    for (const child of group.children || []) {
      if (child.show?.() === false) continue;
      items.push({
        route: child.route,
        label: child.label,
        group: group.label || 'Administration',
      });
    }
  }
  return items;
}

export default function CommandPalette() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen((o) => !o);
        setTick((t) => t + 1);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const items = useMemo(() => flattenNav(), [open, tick]);

  const byGroup = useMemo(() => {
    const map = new Map();
    for (const item of items) {
      if (!map.has(item.group)) map.set(item.group, []);
      map.get(item.group).push(item);
    }
    return [...map.entries()];
  }, [items]);

  const go = (route) => {
    setOpen(false);
    navigate(`/${route}`);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Go to page…" />
      <CommandList>
        <CommandEmpty>No matching pages.</CommandEmpty>
        {byGroup.map(([group, groupItems]) => (
          <CommandGroup key={group} heading={group}>
            {groupItems.map((item) => (
              <CommandItem
                key={item.route}
                value={`${item.label} ${item.route}`}
                onSelect={() => go(item.route)}
              >
                {item.label}
                <CommandShortcut>/{item.route}</CommandShortcut>
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
